module.exports = __webpack_public_path__ + "img/close.b5adff18.svg";